const HELP_ROUTE_MAP = {
  '/dashboard': 'dashboard',
  '/profiles': 'profiles',
  '/documents': 'documents',
  '/accounts': 'accounts',
  '/transactions': 'transactions',
  '/internal-mail': 'internal-mail',
  '/support': 'support',
  '/partners': 'partners',
  '/commissions': 'commissions',
  '/commission-plans': 'commission-plans',
  '/system/users': 'system-users',
  '/system/settings': 'system-settings',
  '/system/user-settings': 'system-user-settings',
  '/system/user-settings/backup-restore': 'system-save-restore',
  '/system/security': 'system-security',
  '/system/events': 'system-events',
  '/system/metrics': 'system-events',
  '/system/save-restore': 'system-save-restore',
  '/system/compliance': 'system-compliance',
  '/payment-settings/providers': 'payment-settings-providers',
  '/payment-settings/bank-transfer': 'payment-settings-bank',
  '/payment-settings/crypto-transfer': 'payment-settings-crypto',
};

const HELP_PLAYBOOK_MAP = {
  dashboard: ['daily-operations-checklist'],
  profiles: ['register-and-verify-client', 'investigate-client-activity'],
  documents: ['process-client-document', 'register-and-verify-client', 'review-withdrawal'],
  accounts: ['open-or-sync-trading-account', 'approve-deposit', 'review-withdrawal'],
  transactions: ['approve-deposit', 'review-withdrawal', 'investigate-client-activity'],
  support: ['resolve-support-ticket'],
  partners: ['check-partner-attribution'],
  commissions: ['check-partner-attribution'],
  'commission-plans': ['check-partner-attribution'],
};

function normalizeViewerSlug(slug) {
  return String(slug || '').trim().replace(/^\/+|\/+$/g, '');
}

export function resolveHelpSlug(pathname) {
  const normalized = pathname.replace(/\/+$/, '') || '/';

  if (HELP_ROUTE_MAP[normalized]) {
    return HELP_ROUTE_MAP[normalized];
  }

  // Walk up the path to find the closest parent match
  const segments = normalized.split('/').filter(Boolean);
  for (let i = segments.length - 1; i > 0; i--) {
    const parent = '/' + segments.slice(0, i).join('/');
    if (HELP_ROUTE_MAP[parent]) {
      return HELP_ROUTE_MAP[parent];
    }
  }

  return null;
}

export function buildHelpViewerPath(slug) {
  const normalized = normalizeViewerSlug(slug);
  return normalized ? `/help-view/${encodeURIComponent(normalized)}` : '/help-view';
}

export function getHelpPlaybookSlugs(slug) {
  const normalized = normalizeViewerSlug(slug);
  return HELP_PLAYBOOK_MAP[normalized] || [];
}

export { HELP_PLAYBOOK_MAP, HELP_ROUTE_MAP };
